module.exports = __webpack_public_path__ + "static/img/13.34097c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/13.png
// module id = cXfx
// module chunks = 0